const round2 = value => Math.round(value * 100) / 100

// One column per repetition, between the Metric column and the Total.
const repetitionCols = repeatAd =>
  Array.from({ length: repeatAd }, (_, i) => ({ type: 'value', title: `Repetition ${i + 1}` }))

export const calcTableProps = ({ answer, config, options = [], repeatAd = 0 }) => {
  const targets = answer?.targets || {}
  const isLoading = 'loading' == answer

  // absent selection means no filter; an empty one is a deliberate state and yields no rows
  const metrics = config?.metrics ? options.filter(option => config.metrics.includes(option.value)) : options

  const cols = [{ type: 'title', title: 'Metric' }, ...repetitionCols(repeatAd), { type: 'value', title: 'Total' }]

  const rows = metrics.map((option, index) => {
    const values = Array.from({ length: repeatAd }, (_, i) => round2(targets[i + 1]?.[option.value] || 0))
    const total = values.reduce((acc, value) => acc + value, 0)

    return {
      cells: [
        { title: `${option.label}<small>${option.metric}</small>`, colorIndex: 0 },
        ...values.map(value => ({ value, loading: isLoading })),
        {
          // the only value-shaping on this surface: average view duration is a mean over
          // the repetitions, not a sum (a zero repetition count falls back to one)
          value: 'averageView' === option.value ? round2(total / (repeatAd || 1)) : total,
          loading: isLoading
        }
      ],
      position: index + 1
    }
  })

  return { cols, rows }
}
